// logsApi.js
const WORKER_URL = "https://zappier-proxy-log-controller.ream-850.workers.dev/";

export const logAction = async (actionType, userEmail, details, resourceID, additionalInfo = "") => {
    const logData = {
        type: "log",
        userId: userEmail,
        action: actionType,
        details: `${details} | Resource ID: ${resourceID}`,
        timestamp: new Date().toISOString(),
        additionalInfo,
    };

    try {
        const response = await fetch(WORKER_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(logData),
        });

        if (response.ok) {
            console.log("Data sent successfully!");
        } else {
            console.error("Failed to send data:", response.statusText);
        }
    } catch (error) {
        console.error("Error sending request:", error);
    }
};


export const supportTicket = async (userEmail, additionalInfo) => {
    const logData = {
        type: "ticket",
        userId: userEmail,
        additionalInfo,
    };

    try {
        const response = await fetch(WORKER_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(logData),
        });

        if (response.ok) {
            console.log("Data sent successfully!");
        } else {
            console.error("Failed to send data:", response.statusText);
        }
    } catch (error) {
        console.error("Error sending request:", error);
    }
};

export const logEmployeeActivity = async (actionType, userEmail, userRole, additionalInfo = "") => {
    const logData = {
        type: "employee_activity",
        userId: userEmail,
        action: actionType,
        userRole: userRole,
        details: additionalInfo,
        timestamp: new Date().toISOString(),
        sessionInfo: {
            userAgent: navigator.userAgent,
            platform: navigator.platform,
            language: navigator.language
        }
    };

    try {
        const response = await fetch(WORKER_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(logData),
        });

        if (response.ok) {
            console.log("Employee activity logged successfully!");
        } else {
            console.error("Failed to log employee activity:", response.statusText);
        }
    } catch (error) {
        console.error("Error logging employee activity:", error);
    }
};

